import { ISubmissionPagedRequest } from '../../../../model/ser/submission/request/submission-paged-request';
import { ISubmissionStatusResponse } from '../../../../model/ser/submission/response/submission-status-response';
import { ISubmissionVehicleResponse } from '../../../../model/ser/submission/response/submission-vehicle-response';
import { PeriodErrors } from '../submission-search-utils';

export type SubmissionSearchState = {
    parameters: ISubmissionPagedRequest;
    searchTrigger: number;
    // Só consulta depois de aplicar os parâmetros da URL (evita uma carga sem filtros)
    ready: boolean;
    filtersOpen: boolean;
    periodErrors: PeriodErrors;
    statuses: ISubmissionStatusResponse[];
    vehicles: ISubmissionVehicleResponse[];
    detailId?: number;
    batchId?: number;
    // Incrementado após ações (cancelar, reprocessar) para recarregar os drawers abertos
    refreshVersion: number;
    cancelTarget?: { id: number; title?: string };
};

export enum ACTION_TYPES {
    updateParameter = 'updateParameter',
    triggerSearch = 'triggerSearch',
    applyDeepLink = 'applyDeepLink',
    setPeriodErrors = 'setPeriodErrors',
    setStatuses = 'setStatuses',
    setVehicles = 'setVehicles',
    openDetail = 'openDetail',
    closeDetail = 'closeDetail',
    openBatch = 'openBatch',
    closeBatch = 'closeBatch',
    openCancel = 'openCancel',
    closeCancel = 'closeCancel',
    refresh = 'refresh',
}

export const SubmissionSearchReducer = (state: SubmissionSearchState, action: any): SubmissionSearchState => {
    const { type, payload } = action;
    switch (type) {
        case ACTION_TYPES.updateParameter:
            return { ...state, parameters: { ...state.parameters, ...payload } };
        case ACTION_TYPES.triggerSearch:
            return { ...state, searchTrigger: state.searchTrigger + 1, periodErrors: {} };
        case ACTION_TYPES.applyDeepLink:
            return {
                ...state,
                ready: true,
                parameters: { ...state.parameters, ...payload.filters },
                filtersOpen: Object.keys(payload.filters).length > 0,
                detailId: payload.submissionId,
                batchId: payload.submissionId ? undefined : payload.batchId,
            };
        case ACTION_TYPES.setPeriodErrors:
            return { ...state, periodErrors: payload };
        case ACTION_TYPES.setStatuses:
            return { ...state, statuses: payload };
        case ACTION_TYPES.setVehicles:
            return { ...state, vehicles: payload };
        case ACTION_TYPES.openDetail:
            return { ...state, detailId: payload, batchId: undefined };
        case ACTION_TYPES.closeDetail:
            return { ...state, detailId: undefined };
        case ACTION_TYPES.openBatch:
            return { ...state, batchId: payload, detailId: undefined };
        case ACTION_TYPES.closeBatch:
            return { ...state, batchId: undefined };
        case ACTION_TYPES.openCancel:
            return { ...state, cancelTarget: payload };
        case ACTION_TYPES.closeCancel:
            return { ...state, cancelTarget: undefined };
        case ACTION_TYPES.refresh:
            return { ...state, searchTrigger: state.searchTrigger + 1, refreshVersion: state.refreshVersion + 1 };
        default:
            throw new Error(`Unhandled action type: ${type}`);
    }
};
